const eventList = ['mouseup', 'touchend', 'touchcancel', 'dragend']

/**
 * 跨 iframe 检测释放鼠标/触摸事件
 */
export default async function(): Promise<Event> {
  return new Promise(resolve => {
    const parent = window.parent
    const handler = (ev: Event) => {
      resolve(ev)
      eventList.forEach(event => {
        window.removeEventListener(event, handler, true)
        parent && parent.removeEventListener(event, handler, true)
      })
    }
    eventList.forEach(event => {
      window.addEventListener(event, handler, true)
      parent && parent.addEventListener(event, handler, true)
    })
  })
}
